/* @format */

import { api } from '@/scripts/api';

export const RegisteredDealService = {
    /**
     * Get registered deals based on the query options.
     *
     * @param {{
     *      query?: ODataQueryOptions;
     *      signal?: AbortSignal;
     * }} options
     */
    async getRegisteredDeals(options) {
        const queryParams = api.buildODataQuery(options.query ?? {});
        const endpoint = `/service/RegisteredDeals${queryParams}`;
        return api.ajax({
            method: 'GET',
            url: endpoint,
            signal: options.signal,
        });
    },

    /**
     * Get a registered deal by ID.
     *
     * @param {{
     *      id: number;
     *      query?: ODataQueryOptions;
     *      signal?: AbortSignal;
     * }} options
     */
    async getRegisteredDealById(options) {
        return this.getRegisteredDeals({
            query: {
                ...(options.query ?? {}),
                filter: {
                    ...(options.query?.filter ?? {}),
                    Id: options.id,
                },
            },
            signal: options.signal,
        });
    },

    /**
     * Create a new registered deal.
     *
     * @param {Object} registeredDealDto
     */
    async postRegisteredDeal(registeredDealDto) {
        return api.post('/api/RegisteredDeals', registeredDealDto);
    },

    /**
     * Update a registered deal.
     *
     * @param {number} id
     * @param {Object} registeredDealChanges
     */
    async patchRegisteredDeal(id, registeredDealChanges) {
        return api.patch(`/api/RegisteredDeals/${id}`, registeredDealChanges);
    },
};
